import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}whatsapp`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const whatsappApi = {
  postNewSubscribe: (request) => {
    // {
    //     pageid: vm.selectedBot.pageid,
    //     access_token: accessToken,
    //     pagename
    //     theme
    //     ownerid
    // }
    const { body } = request
    return instance().post(`newsubscribe`, body)
  },
  deleteUnlinkApp: (request) => {
    const { config } = request
    return instance().delete('unlink-app', config)
  },
  getWhatsappTemplate: (request) => {
    //name
    //lang
    //status
    //limit
    //offset
    //page_id
    const { config } = request
    return instance().get('template', config)
  },
  postCreateWhatsappTemplate: (request) => {
    //page_id
    //template
    //name
    //lang
    //category
    const { data } = request
    return instance().post('template', data)
  },
  putUpdateWhatsappTemplate: (request) => {
    //page_id
    //template
    const { data, id } = request
    return instance().put(`template/${id}`, data)
  },
  putUpdateActiveWhatsappTemplate: (request) => {
    const { data, id } = request
    return instance().put(`template/active/${id}`, data)
  },
  deleteWhatsappTemplate: (request) => {
    const { data } = request
    return instance().delete(`template`, {
      data: data
    })
  },
  postSendWhatsappTemplate: (request) => {
    //page_id
    //userid
    //template_id
    //lang
    //example
    const { data } = request
    return instance().post('template/send', data)
  }
}

export default whatsappApi



// WEBPACK FOOTER //
// ./src/api/whatsapp.js